(function(){
  'use strict';
  var b=window.STMNBtb;
  if(!b)return;
  var root=(b.config.root||'/').replace(/\/?$/,'/');
  var discountRequest=null;
  // A restored or suspended tab must load the theme for the current promo phase.
  function campaignPhase(){var now=Date.now();return now<Date.parse(b.config.startsAt)?'before':now<Date.parse(b.config.endsAt)?'campaign':'after';}
  var loadedPhase=campaignPhase(),reloading=false;
  b.checkCampaignPhase=function(){
    if(window.Shopify?.designMode||campaignPhase()===loadedPhase)return true;
    if(!reloading){reloading=true;location.reload();}
    return false;
  };
  function phaseGuard(event){
    if(b.checkCampaignPhase())return;
    if(event?.cancelable){event.preventDefault();event.stopImmediatePropagation();}
  }
  window.addEventListener('pageshow',phaseGuard);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)phaseGuard();});
  document.addEventListener('click',phaseGuard,true);
  document.addEventListener('submit',phaseGuard,true);
  if(!window.Shopify?.designMode){
    var boundary=loadedPhase==='before'?Date.parse(b.config.startsAt):loadedPhase==='campaign'?Date.parse(b.config.endsAt):0;
    var untilBoundary=boundary-Date.now();
    if(untilBoundary>0&&untilBoundary<2147482647)setTimeout(phaseGuard,untilBoundary+1000);
  }
  b.previewCheckout=function(){return b.active && Date.now()<Date.parse(b.config.startsAt) && window.Shopify?.theme?.role==='unpublished' && (b.config.previewCodes||[]).length===2;};
  b.checkoutCodes=function(){return b.previewCheckout()?b.config.previewCodes.join(','):b.inWindow()?b.config.code:'';};
  function previewNotice(){
    if(!b.previewCheckout())return;
    var anchor=document.querySelector('#mp-cart-promo [data-mp-btb-note]')||document.querySelector('[data-btb-note]');
    if(!anchor||document.getElementById('stmn-btb-preview-note'))return;
    var note=document.createElement('p');note.id='stmn-btb-preview-note';note.className='stmn-btb-note';note.setAttribute('role','status');
    note.textContent='Anteprima interna: gli sconti di prova vengono applicati anche al checkout.';
    anchor.insertAdjacentElement('afterend',note);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',previewNotice);else previewNotice();
  function setHTML(el,html){if(el&&el.innerHTML!==html)el.innerHTML=html;}
  function setText(el,text){if(el&&el.textContent!==text)el.textContent=text;}
  function error(message){
    var el=document.getElementById('stmn-btb-checkout-error');
    if(!el){el=document.createElement('p');el.id='stmn-btb-checkout-error';el.className='stmn-btb-error';el.setAttribute('role','alert');}
    var targets=[document.getElementById('qa-price')?.parentNode,document.getElementById('mp-cart-messages'),document.querySelector('.cart-summary'),document.querySelector('.kit-mp__checkout-stack'),document.querySelector('.mp__info')];
    var target=targets.find(function(t){return t&&t.getClientRects&&t.getClientRects().length;})||document.body;
    if(el.parentNode!==target)target.appendChild(el);
    el.textContent=message;
  }

  function giftCheckoutFields(){if(!b.inWindow())return;document.querySelectorAll('form[action*="/cart/add"]').forEach(function(form){if(form.querySelector('[data-stmn-gift-note]'))return;var input=document.createElement('input');input.type='hidden';input.name='properties[_Back to Box]';input.value='1 omaggio segreto per ordine';input.dataset.stmnGiftNote='1';form.appendChild(input);});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',giftCheckoutFields);else giftCheckoutFields();
  document.addEventListener('shopify:section:load',giftCheckoutFields);
  b.showError=error;
  function readJSON(response){return response.json().then(function(data){if(!response.ok)throw new Error(data.description||data.message||'Operazione non riuscita. Riprova.');return data;});}
  // Clear an old warning only after a fresh Shopify cart confirms every amount.
  b.clearDiscountError=function(cart){
    if(!cart||!Array.isArray(cart.items)||!Number.isFinite(cart.item_count)||!Number.isFinite(cart.total_price))return false;
    if(cart.item_count&&!b.campaignCartConfirmed(cart))return false;
    document.getElementById('stmn-btb-checkout-error')?.remove();
    return true;
  };
  function confirmDiscount(cart,attempt){
    if(b.clearDiscountError(cart))return Promise.resolve(cart);
    if(attempt>=2)return Promise.reject(new Error('Non riusciamo a confermare gli sconti Back to Box. Riprova prima di procedere al pagamento.'));
    // Re-read after recalculation; never repeat additions or quantity mutations.
    return new Promise(function(resolve){setTimeout(resolve,attempt===0?350:900);})
      .then(function(){return window.STMNCartTransport.request(root+'cart.js',{cache:'no-store'});})
      .then(function(current){return confirmDiscount(current,attempt+1);});
  }
  b.ensureDiscount=function(){
    if(!b.checkCampaignPhase())return Promise.reject(new Error('Stiamo aggiornando la promozione. Attendi il caricamento della pagina.'));
    if(!b.active||!b.checkoutCodes())return Promise.resolve(null);
    if(discountRequest)return discountRequest;
    discountRequest=window.STMNCartTransport.request(root+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:b.checkoutCodes(),attributes:b.previewCheckout()?{'Collaudo Back to Box':'Anteprima interna','Back to Box':''}:{'Collaudo Back to Box':'','Back to Box':'1 omaggio segreto incluso per ordine'}})})
      .then(function(cart){return confirmDiscount(cart,0);}).finally(function(){discountRequest=null;});
    return discountRequest;
  };
  b.checkout=function(){
    if(!b.checkCampaignPhase())return Promise.resolve(false);
    return b.ensureDiscount().then(function(){if(!b.checkCampaignPhase())return false;location.href=root+'checkout'+(b.previewCheckout()?'?discount='+encodeURIComponent(b.checkoutCodes()):'');return true;}).catch(function(e){error(e.message);return false;});
  };
  b.addItems=function(items){
    if(!b.checkCampaignPhase())return Promise.reject(new Error('Stiamo aggiornando la promozione. Attendi il caricamento della pagina.'));
    return window.STMNCartTransport.request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
      .then(function(added){return b.ensureDiscount().catch(function(e){error(e.message);return null;}).then(function(){document.dispatchEvent(new CustomEvent('stmn:cart-changed'));return added;});});
  };
  b.patchItems=function(qty){
    return Array.from(document.querySelectorAll('[data-stmn-patches] [data-patch-option][aria-pressed="true"]')).map(function(el){return {id:Number(el.dataset.variant),quantity:qty};});
  };
  function syncDynamicCheckout(selected, qty) {
    var form = document.getElementById('mp-product-form');
    var container = form?.querySelector('[data-stmn-patch-checkout-items]');
    if (!container) return;
    var variant = window._mp?.variant;
    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (variantInput && variant) variantInput.value = variant.id;
    if (qtyInput) qtyInput.value = qty;
    var signature = JSON.stringify([qty, selected.map(function (option) { return option.dataset.variant; })]);
    if (container.dataset.selection !== signature) {
      var fields = document.createDocumentFragment();
      selected.forEach(function (option, index) {
        // Shopify's native accelerated checkout indexes additional products from 1.
        [['id', option.dataset.variant], ['quantity', qty]].forEach(function (entry) {
          var input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'shopify-additional-items[' + (index + 1) + '][' + entry[0] + ']';
          input.value = entry[1];
          fields.appendChild(input);
        });
      });
      container.replaceChildren(fields);
      container.dataset.selection = signature;
    }
    var wrapper = document.getElementById('mp-dynamic-checkout');
    if (wrapper) wrapper.inert = !!window._mp?.btbBusy;
  }

  function refreshPatches(){
    var picker=document.querySelector('[data-stmn-patches]');if(!picker)return;
    var chosen=Array.from(picker.querySelectorAll('[data-patch-option][aria-pressed="true"]'));
    var extra=chosen.reduce(function(total,el){return total+b.price(el.dataset.price);},0);
    var qty=Math.max(1,Number((document.getElementById('mp-qty-input')||{}).value)||1);
    syncDynamicCheckout(chosen,qty);
    var summary=picker.querySelector('[data-patch-summary]');
    setText(summary,chosen.length?chosen.map(function(el){return el.dataset.name;}).join(' + ')+' · +'+b.money(extra*qty)+(qty>1?' per '+qty+' zaini':''):'Nessuna patch selezionata');
    var text=document.getElementById('mp-atc-text');
    if(text&&!(window._mp&&window._mp.btbBusy)&&!(document.getElementById('mp-atc-btn')||{}).disabled)setText(text,chosen.length?'Aggiungi zaino + patch':(window._mpAddText||'Aggiungi al carrello'));
  }
  document.addEventListener('click',function(e){
    var option=e.target.closest('[data-patch-option]');if(!option||option.disabled)return;
    var chosen=option.getAttribute('aria-pressed')!=='true';
    option.setAttribute('aria-pressed',String(chosen));
    option.setAttribute('aria-label',(chosen?'Rimuovi':'Seleziona')+' patch '+option.dataset.name);
    option.querySelector('[data-patch-state]').textContent=chosen?'✓ Selezionata':'+ Aggiungi';
    refreshPatches();
  });
  document.addEventListener('change',refreshPatches);
  document.addEventListener('input',function(e){if(e.target.id==='mp-qty-input')refreshPatches();});
  document.addEventListener('stmn:variant-changed',refreshPatches);
  b.refreshPatches=refreshPatches;
  if(!b.active){
    refreshPatches();return;
  }

  // Retired BACK15 traces must not activate a second visual price calculation.
  document.addEventListener('formdata',function(e){
    ['filter.v.price.gte','filter.v.price.lte'].forEach(function(name){
      var value=e.formData.get(name);
      if(value!==null&&value!=='')e.formData.set(name,(b.filterOriginal(Number(value)*100,name.endsWith('.gte'))/100).toFixed(2));
    });
  },true);
  try{sessionStorage.removeItem('mp_back15');localStorage.removeItem('mp_back15');}catch(e){}
  try{
    var url=new URL(location.href),changed=false;
    ['back15','mp_back15'].forEach(function(k){if(url.searchParams.has(k)){url.searchParams.delete(k);changed=true;}});
    if(/back15/i.test(url.searchParams.get('discount')||'')){url.searchParams.delete('discount');changed=true;}
    if(changed)history.replaceState(history.state,'',url.pathname+url.search+url.hash);
    document.cookie.split(';').forEach(function(cookie){var parts=cookie.trim().split('=');if(/discount_code|back15/i.test(parts[0])&&(/back15/i.test(decodeURIComponent(parts.slice(1).join('=')))||/back15/i.test(parts[0])))document.cookie=parts[0]+'=; Max-Age=0; Path=/; SameSite=Lax';});
  }catch(e){}

  document.querySelectorAll('[data-patch-option][data-stmn-patch-available="true"]').forEach(function(option){option.disabled=false;});
  refreshPatches();

  // All promotion checkouts go through a verified code, including legacy cart links.
  document.addEventListener('click',function(e){
    var link=e.target.closest('a[href]');
    if(!link)return;
    var url;try{url=new URL(link.href,location.origin);}catch(err){return;}
    if(url.origin!==location.origin||!/^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkout\/?$/.test(url.pathname))return;
    e.preventDefault();e.stopImmediatePropagation();b.checkout();
  },true);
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!(form instanceof HTMLFormElement))return;
    if(/\/cart\/?$/.test(new URL(form.action,location.origin).pathname)&&e.submitter&&e.submitter.name==='checkout'){
      e.preventDefault();e.stopImmediatePropagation();b.checkout();
    }
  },true);
  if(b.inWindow()||b.previewCheckout()){b.ensureDiscount().then(function(){document.dispatchEvent(new CustomEvent('stmn:cart-changed'));}).catch(function(e){error(e.message);});}
})();
